module.exports = __webpack_public_path__ + "media/images/hrms/facebook-circle-43e2b6f2932f454c81bb3c7a1e4dc674.svg";